import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { QuoteRequestService } from '@app/shared/services/quote-request.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-resolve-offers-dialog',
  templateUrl: './resolve-offers-dialog.component.html',
  styleUrls: ['./resolve-offers-dialog.component.scss'],
})
export class ResolveOffersDialogComponent implements OnInit, OnDestroy {
  public sendOfferForm: FormGroup;
  public maxCharacters = 255;
  public minCharacters = 0;
  quoteRequestId: any;
  approvedTerms: number[];
  rejectAll: boolean = false;
  resolveOffers$: Subscription;

  constructor(
    public quoteService: QuoteRequestService,
    public dialogRef: MatDialogRef<ResolveOffersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private router: Router
  ) {
    if (data.maxCharacters) {
      this.maxCharacters = data.maxCharacters;
    }
    this.quoteRequestId = data.quoteRequestId;
    this.approvedTerms = data.approvedTerms;
    this.rejectAll = data.rejectAll;
  }

  ngOnDestroy(): void {
    this.resolveOffers$?.unsubscribe();
  }

  ngOnInit() {
    this.sendOfferForm = this.fb.group({
      notes: new FormControl('', [Validators.minLength(this.minCharacters), Validators.maxLength(this.maxCharacters)]),
    });
  }

  public send() {
    this.sendOfferForm.updateValueAndValidity();

    if (this.sendOfferForm.valid) {
      if (this.rejectAll) {
        this.approvedTerms = [];
        this.router.navigateByUrl(this.router.url.replace('get-quote','youre-done'))
      }
      this.resolveOffers$ = this.quoteService.resolveOffers(this.quoteRequestId, this.approvedTerms, this.sendOfferForm.value.notes).subscribe((x) => {
        this.dialogRef.close({
          success: true,
          quoteFeedback: this.sendOfferForm.value.notes,
        });
        this.router.navigateByUrl(this.router.url.replace('get-quote','youre-done'))
      });
    }
  }
}
